import axios from 'axios'

let config = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
}

export const GetApi = (url, data) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${url}`, config)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                console.log('Error in TeamChoice', err)
                reject(err)
            })
    })
}

export const PostApi = (url, data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${url}`, data)
            .then((res) => {
                console.log(res)
                resolve(res)
            })
            .catch((err) => {
                console.log('Error in TeamChoice', err)
                reject(err)
            })
    })
}
export const PutApi = (url, data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`${url}`, data, config)
            .then((res) => {
                console.log(res)
                resolve(res)
            })
            .catch((err) => {
                console.log('Error in TeamChoice', err)
                reject(err)
            })
    })
}
